import Modal, { modalEvents } from '@common/vanilla_ui/general/modal';
import { isMobile } from '@common/utils/responsive';
import RCBExitIntentForm from './rcbExitIntentForm';
import { setModalShown, shouldShowModal, getCurrentPage } from './util';
import { BLOCKED_EXIT_PAGES, PAGES, RCB_EXIT_INTENT_FORM_CTAS }
  from './constant';
import {
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { eventsTrigger } from './triggers';
import tracking from './tracking';

const MODAL_ID = 'rcb-exit-intent-modal';
const modalElement = document.getElementById(MODAL_ID);
const FORM_ID = 'exit-intent-rcb-form';
const modalForm = document.getElementById(FORM_ID);
const defaultVariant = 'old_rcb_modal';
const DEFAULT_RCB_INTENT = 'new_rcb_widget';
const DEFAULT_PROGRAM = 'academy';
const DEFAULT_RCB_CALLBACKCTAID = 'why-ai-rcb-cta';


const PROGRAM_PRODUCT_MATCHING = {
  academy: 'software_development',
  data_science: 'data_science',
  neovarsity: 'neovarsity',
  devops: 'devops',
};


// Checks the session storage for modal visibility

// Should Trigger the exit intent modal
function shouldTriggerModal(event) {
  return !event.toElement && !event.relatedTarget && event.clientY < 10;
}

function checkAcademyFormAndShowModal() {
  try {
    const formEl = document.getElementById('marketing-form-otp');
    const selectInputEls = formEl?.querySelectorAll(
      'input.sr-select__value-input:not([name="country_code"])'
    ) || [];
    const formInputEls = formEl?.querySelectorAll('input.form-input') || [];
    const inputs = [...selectInputEls, ...formInputEls];
    const isAnyInputFilled = inputs.some(input => input.value.trim() !== '');

    if (!isAnyInputFilled) {
      Modal.open(MODAL_ID, true);
      setModalShown();
    }
  } catch (err) {
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_type: 'rcb-exit-intent-modal-err',
        click_text: `${err}`,
      },
    });
  }
}


function handleEventMobileTrigger() {
  setTimeout(eventsTrigger, 60_000);
}

function handleProgramPageMobileTrigger() {
  setTimeout(checkAcademyFormAndShowModal, 60_000);
}

function triggerMobileModalAfterDelay(delay = 60_000) {
  setTimeout(() => {
    Modal.open(MODAL_ID, true);
    setModalShown();
  }, delay);
}

function focusOutHandler(event) {
  if (shouldTriggerModal(event)) {
    document.removeEventListener('mouseout', focusOutHandler);
    Modal.open(MODAL_ID, true);
  }
}

const getSourceValue = () => {
  const isBtnAction = modalForm?.dataset?.isBtnAction === 'true';
  return isBtnAction ? 'rcb_modal' : 'rcb_exit_intent';
};

function handleModalOpen(id) {
  const sectionSourceValue = getSourceValue();
  if (id === MODAL_ID) {
    setModalShown();
    window.GTMtracker?.pushEvent({
      event: 'gtm_section_view',
      data: {
        section_name: sectionSourceValue,
      },
      action: 'section_view',
    });
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_type: `${sectionSourceValue}-open`,
      },
    });
  }
}

function handleModalClose(id) {
  const sectionSourceValue = getSourceValue();
  if (id === MODAL_ID) {
    Modal.close(MODAL_ID);
    setModalShown();
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_type: `${sectionSourceValue}-close`,
      },
    });
  }
}

function initListeners() {
  const currentPage = getCurrentPage();
  if (BLOCKED_EXIT_PAGES.includes(currentPage)) {
    return;
  }

  if (isMobile()) {
    switch (currentPage) {
      case PAGES.EVENT:
        handleEventMobileTrigger();
        break;
      case PAGES.EVENT_TY_PAGE:
        triggerMobileModalAfterDelay(30_000);
        break;
      case PAGES.COMPLETED_EVENT:
        triggerMobileModalAfterDelay(30_000);
        break;
      case PAGES.DSML:
        handleProgramPageMobileTrigger();
        break;
      case PAGES.ACADEMY:
        handleProgramPageMobileTrigger();
        break;
      case PAGES.AIML:
        handleProgramPageMobileTrigger();
        break;
      default:
        triggerMobileModalAfterDelay(60_000);
        break;
    }
  } else {
    switch (currentPage) {
      default:
        document.addEventListener('mouseout', focusOutHandler);
        break;
    }
  }
}


const setCtaClickAttribution = (intent, program) => {
  setAttribution(intent, {
    program: PROGRAM_PRODUCT_MATCHING[program],
  });
};

const getExperimentValue = (experimentKey) => {
  const experimentContainer = document.querySelector(
    `[data-variant-key=${experimentKey}]`,
  );

  const experimentValue = experimentContainer?.getAttribute(
    'data-variant-value',
  );
  return experimentValue || defaultVariant;
};

function initCtaListeners() {
  const closeBtn = modalElement?.querySelector('.rcb-exit-intent__close-btn');

  RCB_EXIT_INTENT_FORM_CTAS.forEach(([callbackCtaId, , program, intent]) => {
    const btns = document.querySelectorAll(`#${callbackCtaId}`);
    if (btns) {
      btns.forEach((btn) => {
        const variantValue = getExperimentValue('growth-tech_new-rcb-modal');
        const variantValue2 = getExperimentValue(
          'growth-tech_combined-rcb-modal',
        );
        btn.addEventListener('click', () => {
          if (variantValue === defaultVariant
            && callbackCtaId !== DEFAULT_RCB_CALLBACKCTAID
              && variantValue2 === defaultVariant) {
            return;
          }
          modalForm.setAttribute?.('data-is-btn-action', 'true');
          modalForm.setAttribute?.('data-click-source', callbackCtaId);
          modalElement?.setAttribute?.('data-is-btn-action', 'true');
          modalElement?.setAttribute?.('data-click-source', callbackCtaId);
          Modal.open(MODAL_ID, true);
          setCtaClickAttribution(
            intent || DEFAULT_RCB_INTENT,
            program || DEFAULT_PROGRAM,
          );
        });
      });
    }
  });

  closeBtn?.addEventListener('click', () => {
    const isBtnAction = modalElement?.dataset?.isBtnAction === 'true';

    if (isBtnAction) {
      modalElement?.setAttribute('data-is-btn-action', 'false');
    }

    if (modalElement?.hasAttribute('data-click-source')) {
      modalElement?.removeAttribute('data-click-source');
    }

    tracking.closeBtnTracking();
  });
}

// Track Modal events
function setupModalEvents() {
  modalEvents.on('open', handleModalOpen);
  modalEvents.on('dismissed', handleModalClose);
}

function ExitIntentInit() {
  // To init check if the user is eligible to show the modal
  if (modalElement) {
    RCBExitIntentForm.initialize();
    setupModalEvents();
    initCtaListeners();

    if (shouldShowModal()) {
      initListeners();
    }
  }
}

export default { initialize: ExitIntentInit };
